import { useState } from "react";
import { useAudit } from "@/api/hooks";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export default function AuditPage() {
  const [admin, setAdmin] = useState("");
  const [target, setTarget] = useState("");
  const [action, setAction] = useState("");
  const { data, isLoading } = useAudit({ admin, target, action });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-heading text-3xl font-light sm:text-4xl">
          <span className="text-bitrefinery-red">A</span>udit log
        </h1>
        <p className="mt-2 text-sm text-bitrefinery-text text-body">
          Every mutating action, most recent first.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 rounded-2xl border border-border bg-card p-5 shadow-sm sm:grid-cols-3">
        <div className="space-y-1.5">
          <Label htmlFor="f-admin">Admin</Label>
          <Input id="f-admin" value={admin} onChange={(e) => setAdmin(e.target.value)} />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="f-action">Action</Label>
          <Input
            id="f-action"
            placeholder="mailbox.create"
            value={action}
            onChange={(e) => setAction(e.target.value)}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="f-target">Target</Label>
          <Input id="f-target" value={target} onChange={(e) => setTarget(e.target.value)} />
        </div>
      </div>

      <div className="overflow-hidden rounded-2xl border border-border bg-card shadow-sm">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>When</TableHead>
              <TableHead>Admin</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Target</TableHead>
              <TableHead>IP</TableHead>
              <TableHead>Details</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={6} className="text-center text-muted-foreground">
                  Loading…
                </TableCell>
              </TableRow>
            )}
            {data?.entries.map((e) => (
              <TableRow key={e.id}>
                <TableCell className="whitespace-nowrap text-muted-foreground">
                  {new Date(e.at).toLocaleString()}
                </TableCell>
                <TableCell className="font-mono text-sm">{e.admin_email}</TableCell>
                <TableCell className="font-mono text-xs">{e.action}</TableCell>
                <TableCell className="font-mono text-sm">{e.target || "—"}</TableCell>
                <TableCell className="text-muted-foreground">{e.ip || "—"}</TableCell>
                <TableCell className="max-w-xs truncate font-mono text-xs text-muted-foreground">
                  {Object.keys(e.details).length ? JSON.stringify(e.details) : "—"}
                </TableCell>
              </TableRow>
            ))}
            {data && data.entries.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center text-muted-foreground">
                  No matching entries.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
